import React, { useContext, useState } from "react";
import {
  Box,
  Grid,
  Avatar,
  IconButton,
  Tooltip,
  Modal,
  Button,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { formatDateTime, isSameDay,formatDate, formatTime} from "../../utils/DateUtils";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import ApiEndpoints from "../../network/ApiEndPoints";
import AuthContext from "../../store/AuthContext";
import AttandanceOutModal from "./AttandanceOutModal";
import AttendanceEmpModal from "./AttandanceEmpModal";
import ViewAttendanceModal from "../../modals/ViewAttendanceModal";
import DataFilter from "./Common/DataFilter";
import ScheduleRoaster from "./ScheduleRoaster";
import MarkAttendanceModal from "./MarkAttendanceModal";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
const Attendance = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  const [query, setQuery] = useState("");
  const [apiData, setApiData] = useState([]);
  let refresh;

  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const closeImageModal = () => {
    setOpenModal(false);
    setZoom(1);
  };
  const has12HoursPassed = (createdAt) => {
    if (!createdAt) return false;
    const inTime = new Date(createdAt);
    const now = new Date();
    const diffHours = (now - inTime) / (1000 * 60 * 60); // milliseconds → hours
    return diffHours >= 12; // disable after 12 hours
  };
 
  const columns = [
    {
      name: "Employee Name",
      selector: (row) => <div>{row.user_name}</div>,
    },
    {
      name: "Employee Role",
      selector: (row) => <div>{row.role || "NA"}</div>,
    },
    {
      name: "Type",
      selector: (row) => <div>{row.type}</div>,
    },
    {
      name: "In Time",
      selector: (row) => (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <div style={{ color: row.in_mark === "RED" ? "red" : "green" }}>
              {formatDateTime(row.created_at)}
            </div>
          </Box>
    
          <Box display="flex" justifyContent="flex-end">
            {row.in_selfie && (
              <img
                src={row.in_selfie}
                alt="in selfie"
                onClick={() => openImageModal(row.in_selfie)}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              />
            )}
          </Box>
        </Box>
      ),
      width: "250px",
    },
    
    {
      name: "Out Time",
      selector: (row) => {
        const sameDay = isSameDay(row.created_at);
        const isOutMarked = row.created_at !== row.updated_at;
    
        // 🔹 ADMIN VIEW
        if (user.role === "Admin") {
          if (row.out_selfie && isOutMarked) {
            return (
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box style={{ color: row.out_mark === "RED" ? "red" : "green" }}>
                  <div>
                    {formatDate(row.updated_at)} {formatTime(row.updated_at)}
                  </div>
                </Box>
    
                <Avatar
                  src={row.out_selfie}
                  onClick={() => openImageModal(row.out_selfie)}
                  sx={{ width: 40, height: 40, cursor: "pointer" }}
                />
              </Box>
            );
          }
    
          return (
            <button
              style={{
                padding: "5px 10px",
                background: "gray",
                color: "white",
                border: "none",
                borderRadius: "5px",
              }}
              disabled={!sameDay}
            >
              Not marked
            </button>
          );
        }
    
        // 🔹 USER VIEW
        return !isOutMarked ? (
          <MarkAttendanceModal
            mode="out"
            row={row}
            refresh={refresh}
            disabled={has12HoursPassed(row.created_at)}
          />
        ) : (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box style={{ color: row.out_mark === "RED" ? "red" : "green" }}>
              <div>
                {formatDate(row.updated_at)} {formatTime(row.updated_at)}
              </div>
            </Box>
    
            <Avatar
              src={row.out_selfie}
              onClick={() => openImageModal(row.out_selfie)}
              sx={{ width: 40, height: 40, cursor: "pointer" }}
            />
          </Box>
        );
      },
      width: "250px",
    },    
    {
      name: "Total Working Hours",
      selector: (row) => {
        if (row.created_at !== row.updated_at) {
          const start = new Date(row.created_at);
          const end = new Date(row.updated_at);
          const diffInMinutes = (end - start) / 1000 / 60;

          const hours = Math.floor(diffInMinutes / 60);
          const minutes = Math.round(diffInMinutes % 60);

          return (
            <div>
              {hours} hours {minutes} minutes
            </div>
          );
        } else {
          return <div>--</div>;
        }
      },
    },
    {
      name: "Remark",
      selector: (row) => <div>{row.remark}</div>,
    },
  ];

  return (
    <Box sx={{ mt: 3.1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DataFilter
          ifemployeeFilter={user.role === "Admin"}
          ifDateFilter={user.role === "Admin"}
          setQuary={setQuery}
          setQuery={setQuery}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}>
          <Tooltip title="Refresh">
            <IconButton
              aria-label="refresh"
              sx={{ color: "#0F52BA" }}
              onClick={() => refreshFunc(setQuery)}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>

          {user.role !== "Admin" && (
            <MarkAttendanceModal
              mode="in"
              openModal={true}
              refresh={() => {
                if (refresh) refresh(); // attendance list reload
              }}
              triggerButton={
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#2F3B57",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <AddCircleOutlineOutlinedIcon />
                  Attendance
                </Button>
              }
            />
          )}
          {(user?.role === "Admin" || user?.id === 6030) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenScheduleModal(true)}
              sx={{ mr: 1 }}
            >
              Change Schedule
            </Button>
          )}
        </Box>
      </Box>

      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_ATTENDANCE}
        columns={columns}
        apiData={apiData}
        setApiData={setApiData}
        queryParam={query}
        returnRefetch={(ref) => {
          refresh = ref;
        }}
      />

      {openModal && (
        <ViewAttendanceModal
          open={openModal}
          selectedImage={selectedImage}
          closeImageModal={closeImageModal}
        />
      )}

      {openScheduleModal && (
        <ScheduleRoaster
          open={openScheduleModal}
          onClose={() => setOpenScheduleModal(false)}
          refresh={refresh}
        />
      )}
    </Box>
  );
};

export default Attendance;
